import React from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Checkbox,
  Box,
} from "@mui/material";

const CardCheckboxWidget = ({
  id,
  value,
  label,
  onChange,
  disabled,
  readonly,
  schema,
  rawErrors = [],
}) => {
  const hasError = rawErrors.length > 0;

  const handleChange = () => {
    if (!readonly && !disabled) {
      onChange(value ? undefined : true);
    }
  };

  return (
      <Card
        variant="outlined"
        sx={{
          borderColor: hasError
            ? "error.main"
            : value
            ? "primary.main"
            : "grey.300",
          boxShadow: value ? "0 0 10px 0 rgba(137, 7, 31, 0.15)" : 0,
          borderRadius: 2,
          cursor: "pointer",
        }}
      >
        <CardActionArea onClick={handleChange}>
          <CardContent sx={{ display: "flex", alignItems: "flex-start" }}>
            <Checkbox
              checked={!!value}
              tabIndex={-1}
              disabled={disabled || readonly}
              inputProps={{ "aria-labelledby": id }}
              sx={{ p: 0, pr: 1 }}
            />
            <Box>
              <Typography variant="body1" component="div">
                {schema?.title || label}
              </Typography>
              {schema?.description && (
                <Typography variant="caption" color="text.secondary">
                  {schema.description}
                </Typography>
              )}
            </Box>
          </CardContent>
        </CardActionArea>
      </Card>
  );
};

export default CardCheckboxWidget;
